/* ────────────────────────────────────────────────────────────
   CUSHION BUILDER JS
   ────────────────────────────────────────────────────────────
   Handles: variant selection, dimension sliders, base/material cards,
   quantity controls, fittings, and form submission to Cloudflare Worker.

   PRICING: Pre-computed correct total is stored in form.dataset.computedTotal
   by the Liquid IIFE. This JS reads it for display and submission.
   ──────────────────────────────────────────────────────────── */

window.CushionBuilder = {
  init: function(cfg) {
    var sid = cfg.sid;
    var DEF_LENGTH = cfg.defLength;
    var DEF_DEPTH = cfg.defDepth;
    var currentRate = parseFloat(cfg.defRate) >= 0 ? parseFloat(cfg.defRate) : 30;
    var currentAddon = parseFloat(cfg.defAddon) || 0;
    var state = { length: DEF_LENGTH, depth: DEF_DEPTH };
    var qty = 1;
    var designName = cfg.designName || 'Custom';  /* Design name from product title */
    var pricingTable = cfg.pricingTable || {};     /* Thickness-based rates */

    /* Get pre-computed total from Liquid IIFE dataset */
    function getComputedTotal() {
      var form = document.getElementById('product-form-' + sid);
      if (form && form.dataset.computedTotal) {
        return parseInt(form.dataset.computedTotal) || 0;
      }
      return 0;
    }

    /* Fallback calculation (in case Liquid IIFE didn't run) */
    function calcPriceFallback() {
      var areaSqft = state.length * state.depth / 929.03;
      var sqftPrice = areaSqft * currentRate;
      var total = (sqftPrice + currentAddon) * qty;
      return Math.round(total);
    }

    var priceInteracted = false;

    function updatePriceDisplay(fromInteraction) {
      var el = document.getElementById('priceDisplay-' + sid);
      if (el) {
        /* Prefer pre-computed total from Liquid; fallback to calculation */
        var computed = getComputedTotal();
        var price = computed > 0 ? computed : calcPriceFallback();
        el.textContent = '$' + price;
      }
      if (fromInteraction && !priceInteracted) {
        priceInteracted = true;
        var labelEl = document.getElementById('priceLabel-' + sid);
        if (labelEl) labelEl.textContent = 'Your price';
      }
    }

    var variantRates = cfg.variantRates || {};
    var propDesignEl = document.getElementById('propDesign-' + sid);
    var mainImg = document.getElementById('mainProductImg-' + sid);
    var variantPicker = document.getElementById('variantPicker-' + sid);

    function applyVariant(radio) {
      var rate = variantRates[radio.value];
      if (rate !== undefined) {
        currentRate = parseFloat(rate);
      }
      if (propDesignEl) {
        propDesignEl.value = radio.dataset.title || '';
      }
      if (mainImg && radio.dataset.image) {
        mainImg.src = radio.dataset.image;
      }
    }

    var checkedRadio = variantPicker ? variantPicker.querySelector('input.nw-variant-radio:checked') : null;
    if (checkedRadio) applyVariant(checkedRadio);

    if (variantPicker) {
      variantPicker.addEventListener('click', function(e) {
        var label = e.target.closest('label.nw-variant-tile');
        if (label) {
          var radio = document.getElementById(label.getAttribute('for'));
          if (radio) {
            applyVariant(radio);
            updatePriceDisplay(true);
          }
        }
      });
    }

    /* Thumbnail carousel */
    var thumbsStrip = document.getElementById('mediaThumbs-' + sid);
    var thumbsPrev = document.getElementById('thumbsPrev-' + sid);
    var thumbsNext = document.getElementById('thumbsNext-' + sid);

    if (thumbsStrip) {
      thumbsStrip.addEventListener('click', function(e) {
        var btn = e.target.closest('.nw-thumb-btn');
        if (btn) {
          if (mainImg && btn.dataset.src) {
            mainImg.src = btn.dataset.src;
          }
          thumbsStrip.querySelectorAll('.nw-thumb-btn').forEach(function(b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');
        }
      });

      var scrollAmt = 200;
      if (thumbsPrev) {
        thumbsPrev.addEventListener('click', function(e) {
          e.preventDefault();
          thumbsStrip.scrollLeft -= scrollAmt;
        });
      }
      if (thumbsNext) {
        thumbsNext.addEventListener('click', function(e) {
          e.preventDefault();
          thumbsStrip.scrollLeft += scrollAmt;
        });
      }
    }

    /* Dimension sliders (legacy — no longer used, but kept for compatibility) */
    var sliders = [
      {
        range: document.getElementById('sliderLength-' + sid),
        fill: document.getElementById('fillLength-' + sid),
        num: document.getElementById('numLength-' + sid),
        badge: document.getElementById('badgeL-' + sid),
        prop: document.getElementById('propLength-' + sid),
        key: 'length'
      },
      {
        range: document.getElementById('sliderDepth-' + sid),
        fill: document.getElementById('fillDepth-' + sid),
        num: document.getElementById('numDepth-' + sid),
        badge: document.getElementById('badgeD-' + sid),
        prop: document.getElementById('propDepth-' + sid),
        key: 'depth'
      }
    ];

    function updateFill(s) {
      if (s.range && s.fill) {
        var pct = (s.range.value - s.range.min) / (s.range.max - s.range.min) * 100;
        s.fill.style.width = pct + '%';
      }
    }

    function syncSlider(s) {
      var val = parseInt(s.range.value);
      state[s.key] = val;
      if (s.num) s.num.value = val;
      if (s.badge) s.badge.textContent = val;
      if (s.prop) s.prop.value = val + 'cm';
      updateFill(s);
      updatePriceDisplay(true);
    }

    sliders.forEach(function(s) {
      if (s.range) {
        s.range.addEventListener('input', function() {
          syncSlider(s);
        });
        if (s.num) {
          s.num.addEventListener('input', function() {
            var v = parseInt(s.num.value) || parseInt(s.range.min);
            v = Math.min(Math.max(v, parseInt(s.range.min)), parseInt(s.range.max));
            s.range.value = v;
            syncSlider(s);
          });
          s.num.addEventListener('blur', function() {
            s.num.value = parseInt(s.range.value);
          });
        }
        syncSlider(s);
      }
    });

    /* Quantity controls */
    var qtyDisplay = document.getElementById('qty-' + sid);
    var qtyInput = document.getElementById('qtyInput-' + sid);

    document.querySelectorAll('[data-target="qty-' + sid + '"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.dataset.action === 'down' && qty > 1) {
          qty--;
        } else if (btn.dataset.action === 'up') {
          qty++;
        }
        if (qtyDisplay) qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
        var form = document.getElementById('product-form-' + sid);
        if (form) form.dispatchEvent(new CustomEvent('nw:qty-changed'));
        updatePriceDisplay(true);
      });
    });

    /* Fittings grid (if used) */
    var fittingsGrid = document.getElementById('fittingsGrid-' + sid);
    var propFittings = document.getElementById('propFittings-' + sid);
    var fittingsSummary = document.getElementById('fittingsSummary-' + sid);

    function syncFittings() {
      if (fittingsGrid) {
        var selected = [];
        fittingsGrid.querySelectorAll('.nw-fitting-card').forEach(function(card) {
          if (card.classList.contains('selected')) {
            selected.push(card.dataset.fitting);
          }
        });
        if (propFittings) propFittings.value = selected.join(', ');
        if (fittingsSummary) {
          fittingsSummary.textContent = selected.length ? selected.length + ' option' + (selected.length > 1 ? 's' : '') + ' selected' : '';
        }
      }
    }

    if (fittingsGrid) {
      fittingsGrid.querySelectorAll('.nw-fitting-card').forEach(function(card) {
        card.addEventListener('click', function() {
          card.classList.toggle('selected');
          syncFittings();
        });
      });
      syncFittings();
    }

    /* Cushion Base grid */
    var baseGrid = document.getElementById('baseGrid-' + sid);
    var propBase = document.getElementById('propBase-' + sid);

    if (baseGrid) {
      var defaultBase = baseGrid.querySelector('.nw-base-card.selected');
      if (defaultBase) {
        currentAddon = parseFloat(defaultBase.dataset.addon) || 0;
        if (propBase) propBase.value = defaultBase.dataset.base || '';
      }

      baseGrid.querySelectorAll('.nw-base-card').forEach(function(card) {
        card.addEventListener('click', function() {
          baseGrid.querySelectorAll('.nw-base-card').forEach(function(c) {
            c.classList.remove('selected');
          });
          card.classList.add('selected');
          currentAddon = parseFloat(card.dataset.addon) || 0;
          if (propBase) propBase.value = card.dataset.base || '';
          updatePriceDisplay(true);
        });
      });
    }

    /* Material/Fabric grid */
    var materialGrid = document.getElementById('materialGrid-' + sid);
    var propMaterial = document.getElementById('propMaterial-' + sid);
    var materialSelected = document.getElementById('materialSelected-' + sid);
    var fabricInfoEl = document.getElementById('fabricInfo-' + sid);
    var fabricInfoName = fabricInfoEl ? fabricInfoEl.querySelector('.nw-fabric-info__name') : null;
    var fabricInfoDesc = fabricInfoEl ? fabricInfoEl.querySelector('.nw-fabric-info__desc') : null;

    function syncMaterials() {
      if (materialGrid) {
        var chosen = null;
        var chosenDesc = null;
        materialGrid.querySelectorAll('.nw-material-card').forEach(function(card) {
          if (card.classList.contains('selected')) {
            chosen = card.dataset.material;
            chosenDesc = card.dataset.desc || '';
          }
        });
        if (propMaterial) propMaterial.value = chosen || '';
        if (materialSelected) materialSelected.textContent = chosen || '';
        if (fabricInfoEl) {
          fabricInfoEl.classList.toggle('visible', !!chosen);
          if (fabricInfoName) fabricInfoName.textContent = chosen || '';
          if (fabricInfoDesc) {
            fabricInfoDesc.textContent = chosenDesc || '';
            fabricInfoDesc.style.display = chosenDesc ? 'block' : 'none';
          }
        }
      }
    }

    if (materialGrid) {
      materialGrid.querySelectorAll('.nw-material-card').forEach(function(card) {
        card.addEventListener('click', function() {
          materialGrid.querySelectorAll('.nw-material-card').forEach(function(c) {
            c.classList.remove('selected');
          });
          card.classList.add('selected');
          syncMaterials();
          updatePriceDisplay(true);
        });
      });
      syncMaterials();
    }

    /* Form submission */
    var form = document.getElementById('product-form-' + sid);
    var cartBtn = document.getElementById('cartBtn-' + sid);

    if (form && cartBtn) {
      var cartIconSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;opacity:0.8"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
      var spinnerSVG = '<span class="nw-btn-spinner" style="display:inline-block;vertical-align:middle;margin-right:6px;"></span>';

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var workerUrl = form.dataset.workerUrl;
        var computedTotal = parseInt(form.dataset.computedTotal) || 0;

        cartBtn.disabled = true;

        if (workerUrl) {
          cartBtn.innerHTML = spinnerSVG + ' Processing…';
          /* Get on-site service selection */
          var propOnsiteService = document.getElementById('propOnsiteService-' + sid);
          var onsiteServiceVal = propOnsiteService ? propOnsiteService.value : 'No';

          /* Get selected thickness */
          var thickEl = document.getElementById('selThickness-' + sid);
          var thickness = thickEl ? thickEl.value : '7.5cm';

          fetch(workerUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              title: form.dataset.productTitle || 'Custom Cushion',
              length: state.length,
              depth: state.depth,
              rate: currentRate,
              addon: currentAddon,
              qty: qty,
              total: computedTotal,  /* Pre-computed correct total (qty-multiplied, includes all surcharges) */
              design: propDesignEl ? propDesignEl.value : '',
              designName: designName,  /* Design name extracted from product title */
              thickness: thickness,    /* Selected thickness (5cm/7.5cm/10cm) */
              pricingTable: pricingTable,  /* Send pricing table for worker validation */
              fittings: propFittings ? propFittings.value : '',
              base: propBase ? propBase.value : '',
              material: propMaterial ? propMaterial.value : '',
              onsiteService: onsiteServiceVal
            })
          })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data.url) {
                cartBtn.innerHTML = cartIconSVG + ' Proceed to Checkout';
                cartBtn.disabled = false;
                showCheckoutConfirm(data.url, computedTotal || data.total, cartIconSVG);
              } else {
                throw new Error('No invoice URL returned');
              }
            })
            .catch(function() {
              cartBtn.innerHTML = cartIconSVG + ' Something went wrong — try again';
              cartBtn.disabled = false;
            });
        } else {
          cartBtn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          })
            .then(function(r) { return r.json(); })
            .then(function() {
              cartBtn.textContent = '✓ Added to Cart';
              cartBtn.style.background = '#4A7C5F';
              setTimeout(function() {
                cartBtn.innerHTML = cartIconSVG + ' Add to Cart';
                cartBtn.style.background = '';
                cartBtn.disabled = false;
              }, 2500);
            })
            .catch(function() {
              form.submit();
            });
        }
      });
    }

    /* Checkout confirmation modal */
    function showCheckoutConfirm(invoiceUrl, total, iconSVG) {
      var existing = document.getElementById('nw-checkout-overlay-' + sid);
      if (existing) existing.remove();

      var designName = (form && form.dataset.productTitle) || (propDesignEl && propDesignEl.value) || 'Custom Design';
      var baseName = (propBase && propBase.value) || 'Plain';
      var fabricName = (propMaterial && propMaterial.value) || '—';
      var fittingsTxt = (propFittings && propFittings.value) || 'None';
      var thicknessVal = (document.getElementById('propThickness-' + sid) || {}).value || '';
      var thickDisplay = thicknessVal ? thicknessVal.replace(/cm$/i, '').trim() : '';
      var displayLength = parseInt(form && form.dataset.computedLength) || state.length;
      var displayDepth = parseInt(form && form.dataset.computedDepth) || state.depth;
      var totalCalc = parseInt(total) || 0;
      /* Get on-site service selection for modal display */
      var propOnsiteService = document.getElementById('propOnsiteService-' + sid);
      var onsiteServiceVal = propOnsiteService ? propOnsiteService.value : 'No';

      function row(label, value, extra) {
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:0.55rem 0;border-bottom:1px solid rgba(74,63,53,0.08);"><span style="font-size:0.8rem;color:#8C7B6B;letter-spacing:0.03em;">' + label + '</span><span style="font-size:0.85rem;color:#2A231C;font-weight:500;text-align:right;max-width:60%;">' + value + (extra ? '<span style="font-size:0.75rem;color:#B07D4A;margin-left:0.4rem;">(' + extra + ')</span>' : '') + '</span></div>';
      }

      function priceRow(label, value, highlight) {
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:0.45rem 0;"><span style="font-size:0.8rem;color:' + (highlight ? '#2A231C' : '#8C7B6B') + ';font-weight:' + (highlight ? '500' : '400') + ';">' + label + '</span><span style="font-size:' + (highlight ? '0.9rem' : '0.82rem') + ';color:' + (highlight ? '#2A231C' : '#4A3F35') + ';font-weight:' + (highlight ? '600' : '400') + ';">$' + value + '</span></div>';
      }

      var baseLabel = currentAddon > 0 ? '+$' + Math.round(currentAddon) : 'Included';
      var qtyLabel = qty + 'x';

      var overlay = document.createElement('div');
      overlay.id = 'nw-checkout-overlay-' + sid;
      overlay.style.cssText = [
        'position:fixed', 'inset:0', 'z-index:9999', 'background:rgba(42,35,28,0.6)',
        'display:flex', 'align-items:center', 'justify-content:center', 'padding:1.25rem',
        'font-family:DM Sans,sans-serif', 'backdrop-filter:blur(3px)'
      ].join(';');

      var cardHtml = [
        '<div style="background:#FDFCFB;border-radius:14px;width:100%;max-width:460px;box-shadow:0 24px 80px rgba(0,0,0,0.28);overflow:hidden;max-height:92vh;display:flex;flex-direction:column;">',
        '<div style="padding:1.5rem 1.75rem 1.25rem;border-bottom:1px solid #EDE8E1;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;">',
        '<div>',
        '<div style="font-size:0.68rem;letter-spacing:0.16em;text-transform:uppercase;color:#B07D4A;margin-bottom:0.3rem;">Order Summary</div>',
        '<div style="font-size:0.9rem;font-weight:600;color:#2A231C;">Please review before checkout</div>',
        '</div>',
        '<button id="nw-confirm-x-' + sid + '" style="width:32px;height:32px;border:none;background:#F0EDE8;border-radius:50%;cursor:pointer;font-size:1rem;line-height:1;color:#4A3F35;display:flex;align-items:center;justify-content:center;flex-shrink:0;" aria-label="Close">&times;</button>',
        '</div>',
        '<div style="padding:1.5rem 1.75rem;overflow-y:auto;flex:1;">',
        '<div style="font-size:0.68rem;letter-spacing:0.14em;text-transform:uppercase;color:#8C7B6B;margin-bottom:0.5rem;">Your Configuration</div>',
        row('Design', designName),
        row('Dimensions', displayLength + ' × ' + displayDepth + (thickDisplay ? ' × ' + thickDisplay : '') + ' cm'),
        row('Cushion Base', baseName, baseLabel),
        row('Fabric', fabricName),
        row('Quantity', qtyLabel),
        (onsiteServiceVal === 'Onsite Service' ? row('On-Site Service', 'Onsite Service', '+$80') : ''),
        '<div style="margin-top:1rem;padding:1rem 1.25rem;background:#F4F0EB;border-radius:8px;display:flex;align-items:center;justify-content:space-between;">',
        '<div style="font-size:0.78rem;letter-spacing:0.08em;text-transform:uppercase;color:#4A3F35;font-weight:500;">Total</div>',
        '<div style="font-size:1.35rem;font-weight:700;color:#2A231C;letter-spacing:-0.02em;">$' + totalCalc + '</div>',
        '</div>',
        '<div style="margin-top:1rem;font-size:0.75rem;color:#8C7B6B;line-height:1.5;">',
        'You will be taken to Shopify\'s secure checkout. Your configuration will be shown in the order notes.',
        '</div>',
        '</div>',
        '<div style="padding:1.25rem 1.75rem;border-top:1px solid #EDE8E1;display:flex;gap:0.75rem;flex-shrink:0;background:#FDFCFB;">',
        '<button id="nw-confirm-back-' + sid + '" style="flex:1;padding:0.85rem 1rem;border:1.5px solid #C8BFB3;background:transparent;border-radius:8px;font-size:0.8rem;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;color:#4A3F35;font-family:inherit;transition:background 0.18s;">',
        '← Go Back',
        '</button>',
        '<a href="' + invoiceUrl + '" style="flex:2;padding:0.85rem 1rem;background:#2A231C;color:#FDFCFB;border-radius:8px;font-size:0.8rem;letter-spacing:0.1em;text-transform:uppercase;text-align:center;text-decoration:none;display:flex;align-items:center;justify-content:center;gap:0.5rem;">',
        iconSVG,
        '<span>Proceed to Payment</span>',
        '</a>',
        '</div>',
        '</div>'
      ].join('');

      overlay.innerHTML = cardHtml;
      document.body.appendChild(overlay);

      function dismiss() {
        overlay.remove();
        cartBtn.innerHTML = iconSVG + ' Add to Cart';
        cartBtn.disabled = false;
      }

      document.getElementById('nw-confirm-back-' + sid).addEventListener('click', dismiss);
      document.getElementById('nw-confirm-x-' + sid).addEventListener('click', dismiss);
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) dismiss();
      });
    }

    /* Sticky price bar */
    var priceEl = document.getElementById('priceDisplay-' + sid);
    var stickyBar = document.createElement('div');
    stickyBar.className = 'nw-sticky-price';
    stickyBar.innerHTML = [
      '<div class="nw-sticky-price__left">',
      '<span class="nw-sticky-price__label">Price</span>',
      '<span class="nw-sticky-price__value" id="stickyPrice-' + sid + '">—</span>',
      '</div>',
      '<span class="nw-sticky-price__title">' + (form && form.dataset.productTitle || '') + '</span>',
      '<button class="nw-sticky-price__cta" id="stickyCartBtn-' + sid + '" type="button">',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0;"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>',
      '<span>Add to Cart</span>',
      '</button>'
    ].join('');
    document.body.appendChild(stickyBar);

    var stickyPriceEl = document.getElementById('stickyPrice-' + sid);
    var stickyCartBtn = document.getElementById('stickyCartBtn-' + sid);

    if (stickyCartBtn && form) {
      stickyCartBtn.addEventListener('click', function() {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    /* Show/hide sticky bar on scroll */
    if ('IntersectionObserver' in window) {
      var mobileQuery = window.matchMedia('(max-width: 767px)');
      if (priceEl) {
        new IntersectionObserver(function(entries) {
          if (!mobileQuery.matches) {
            stickyBar.classList.toggle('nw-sticky-price--visible', !entries[0].isIntersecting);
          }
        }, { threshold: 0 }).observe(priceEl);
      }
      if (cartBtn) {
        new IntersectionObserver(function(entries) {
          if (mobileQuery.matches) {
            stickyBar.classList.toggle('nw-sticky-price--visible', !entries[0].isIntersecting);
          }
        }, { threshold: 0 }).observe(cartBtn);
      }
    }

    /* Update sticky price whenever main price updates */
    var origUpdatePrice = updatePriceDisplay;
    updatePriceDisplay = function(fromInteraction) {
      origUpdatePrice(fromInteraction);
      if (stickyPriceEl) {
        var computed = getComputedTotal();
        var price = computed > 0 ? computed : calcPriceFallback();
        stickyPriceEl.textContent = '$' + price;
      }
    };

    updatePriceDisplay();
  }
};
